<template>
  <div class="merchant-container">
    <div class="side-nav">
      <MerchantSideNav />
      <MenuToggle />
    </div>
    <div class="merchant-body transaction-body">
      <header>
        <MerchantHeader />
      </header>
      <div class="dashboard-content">
        <div class="row align-items-center mt-5 pl-3 pl-lg-0">
          <h3>Settings</h3>
          <span class="material-icons mx-3"> arrow_forward_ios </span>
          <h3>Url</h3>
          <span class="env-badge ml-3" :class="isSandbox ? 'is-sandbox' : 'is-live'">
            {{ isSandbox ? 'Sandbox' : 'Live' }}
          </span>
        </div>
        <div class="row">
          <div class="col-12 pl-0">
            <div class="card-style">
              <h3></h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nam,
                sint aliquam dicta assumenda cumque nulla consectetur dolores
                harum error nostrum odio inventore beatae, doloremque provident
                quaerat doloribus in id dolorum.
              </p>

              <div class="row" v-if="isSandbox && !sandboxConfigured">
                <div class="col-12 mb-3">
                  <span style="color: #e08b00; font-weight: 600;">
                    Sandbox host is not configured yet - showing the Live URLs.
                    Set VUE_APP_SANDBOX_SERVICE_URL and VUE_APP_SANDBOX_BASE_URL in your .env file.
                  </span>
                </div>
              </div>

              <div class="row justify-content-center align-items-center">
                <div class="mb-3 col-12 col-lg-6 position-relative">
                  <b-form-input type="text" id="api_root_url" :value="apiRootUrl" readonly> </b-form-input>
                  <span class="position-absolute">Your API Root URL </span>
                  <span style="font-size: 14px; color: #0da90d; font-weight: 600;" v-if="api_url_copied">API Root URL Copied.</span>
                </div>
                <div class=" col-12 col-lg-4">
                  <b-button variant="primary" @click="copyApiRootUrl"><span class="material-icons"> content_copy </span> Copy</b-button>
                </div>
              </div>

              <div class="row justify-content-center align-items-center">
                <div class="mb-3 col-12 col-lg-6 position-relative">
                  <b-form-input type="text" placeholder="Merchant API Payment URL" id="payment_url" :value="merchantPaymentUrl" readonly> </b-form-input>
                  <span class="position-absolute">Your Payment View URL </span>
                  <span style="font-size: 14px; color: #0da90d; font-weight: 600;" v-if="payment_url_copied">Payment URL Copied.</span>
                </div>
                <div class=" col-12 col-lg-4">
                  <b-button variant="primary" @click="copyPaymentUrl"><span class="material-icons"> content_copy </span> Copy</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <MerchantFooter />
    </footer>
  </div>
</template>
<script>
import MerchantHeader from "./MerchantHeader.vue";
import MerchantFooter from "./MerchantFooter.vue";
import MerchantSideNav from "./MerchantSideNav.vue";
import MenuToggle from "./MenuToggle.vue";
import { mapState } from "vuex";

export default {
  components: {
    MerchantHeader,
    MerchantFooter,
    MerchantSideNav,
    MenuToggle,
  },
  data() {
    return {
      payment_url_copied: false,
      api_url_copied: false,
    }
  },
  computed: {
    ...mapState(["merchantEnvironment"]),
    isSandbox: function () {
      return this.merchantEnvironment === "sandbox";
    },
    sandboxConfigured: function () {
      return !!(process.env.VUE_APP_SANDBOX_SERVICE_URL || process.env.VUE_APP_SANDBOX_BASE_URL);
    },
    /** API root differs per environment; sandbox falls back to live if not configured. */
    apiRootUrl: function () {
      if (this.isSandbox) {
        return process.env.VUE_APP_SANDBOX_SERVICE_URL || process.env.VUE_APP_SERVICE_URL || "";
      }
      return process.env.VUE_APP_SERVICE_URL || "";
    },
    baseUrl: function () {
      if (this.isSandbox) {
        return process.env.VUE_APP_SANDBOX_BASE_URL || process.env.VUE_APP_BASE_URL || "";
      }
      return process.env.VUE_APP_BASE_URL || "";
    },
    merchantPaymentUrl: function () {
      const base = this.baseUrl;
      if (!base) { return ""; }
      return base.replace(/\/$/, "") + "/merchant/payment";
    },
  },
  methods: {
    copyApiRootUrl(){
      let el = document.getElementById("api_root_url");
      el.select();
      document.execCommand('copy');
      this.api_url_copied = true;
      setTimeout(() => { this.api_url_copied = false; }, 2000);
    },
    copyPaymentUrl(){
      let paymentUrlValue = document.getElementById("payment_url");
      paymentUrlValue.select();
      document.execCommand('copy');

      this.payment_url_copied = true;
      setTimeout(() => {
        this.payment_url_copied = false;
      }, 2000);
    }
  }
};
</script>
<style lang="scss" scoped>
.env-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.env-badge.is-live { background: #e6f0f8; color: #0066b3; }
.env-badge.is-sandbox { background: #fdf3e0; color: #e08b00; }

</style>